import React, { useMemo } from 'react';
import { css } from '@emotion/react';
import { IoMdCall } from 'react-icons/io';
import { connect } from 'react-redux';
import { startConference, startRoomConference } from '@/_redux/actions/ActionConference';

const JoinCallButtonWhenRoom = React.memo(
    ({ startRoomConference, startConference, roomConferences, conferenceData, room }) => {
        const roomId = room._id || room.id;
        const handleUserCall = () => {
            if (roomId) {
                startRoomConference({ roomId });
            }
        };

        const shouldRenderButton = useMemo(() => {
            if (!roomConferences || typeof roomConferences !== 'object') return false;
            const roomConference = roomConferences[roomId];
            return roomConference?.conferenceId && roomConference.conferenceId !== 'false';
        }, [roomConferences, roomId]);

        if (!shouldRenderButton) {
            return null;
        }

        return (
            <span
                className="callBtn"
                onClick={handleUserCall}
                css={css`
                    margin-left: 1rem;
                    cursor: pointer;
                    transition: transform 150ms;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid white;
                    padding: 0 1rem;
                    border-radius: 5px;
                    :hover {
                        transform: scale(1.1);
                        background-color: white;
                        color: #2e9a9c;
                    }
                `}
            >
                {/* <ToolTip text="Call"> */}
                <IoMdCall fontSize={20} /> <span className="ml-2">Join</span>
                {/* </ToolTip> */}
            </span>
        );
    }
);

const mapStateToProps = (state) => ({
    conferenceData: state.conference.conferenceData,
    roomConferences: state.conference.roomConferences,
});

export default connect(mapStateToProps, {
    startRoomConference,
    startConference,
})(JoinCallButtonWhenRoom);
